
    const scrollToTop = (number=0) => {
      window.scrollTo({
        top: number,
        behavior: 'smooth', // Smooth kaydırma davranışı
      });
    };

  export {scrollToTop}